// Movies Page
import * as React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Box, Typography, Skeleton, Stack } from '@mui/material';
import { motion } from 'framer-motion';
import { Movie as MovieIcon } from '@mui/icons-material';
import { fetchMovies } from '../../hooks/useApi';
import { AnimeCard } from '../../components/ui/Card';

export default function Movies() {
  const { data, isLoading } = useQuery({
    queryKey: ['movies'],
    queryFn: () => fetchMovies(1, 60),
    staleTime: 5 * 60 * 1000,
  });

  const page2 = useQuery({
    queryKey: ['movies', 2],
    queryFn: () => fetchMovies(2, 60),
    staleTime: 5 * 60 * 1000,
  });

  const allMovies = [...(data || []), ...(page2.data || [])];

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" fontWeight={900} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <MovieIcon /> Anime Movies
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {isLoading ? 'Loading...' : `${allMovies.length} anime movies`}
        </Typography>
      </Box>

      {isLoading ? (
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 3 }}>
          {Array.from({ length: 24 }).map((_, i) => (
            <Skeleton key={i} variant="rounded" width="100%" height={300} sx={{ borderRadius: 3 }} />
          ))}
        </Box>
      ) : (
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'repeat(2, 1fr)', sm: 'repeat(3, 1fr)', md: 'repeat(4, 1fr)', lg: 'repeat(5, 1fr)', xl: 'repeat(6, 1fr)' }, gap: 3 }}>
          {allMovies.map((anime: any, index: number) => (
            <motion.div
              key={anime.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: Math.min(index * 0.015, 1) }}
            >
              <AnimeCard
                id={anime.id}
                title={anime.title}
                poster={anime.poster}
                score={anime.score}
                type={anime.type}
                episodes={anime.episodes}
                genres={anime.genres}
                year={anime.year}
                onClick={() => window.location.href = `/anime/${anime.id}`}
              />
            </motion.div>
          ))}
        </Box>
      )}
    </Box>
  );
}